import {BehaviorSubject} from 'rxjs';
import {Injectable} from '@angular/core';
@Injectable( { providedIn: 'root' } )
export class BroadcastService {
    public error: BehaviorSubject<string>;
    constructor() {
        this.error = new BehaviorSubject<string>('');
    }
}
